import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher/LanguageSwitcher';
import { useAuth } from '../../context/AuthContext';
import styles from './Header.module.css';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isLoggedIn, logout } = useAuth();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <header className={styles.header}>
      <img src="/assets/images/logo_svg.svg" alt="Logo" className={styles.logo} />
      
      {/* Hamburger Icon */}
      <div className={styles.hamburger} onClick={toggleMenu}>&#9776;</div>

      {/* Menu */}
      <nav className={`${styles.menu} ${isMenuOpen ? styles.open : ''}`}>
        <LanguageSwitcher />
        {isLoggedIn && (
          <button onClick={logout} className={styles.logoutButton}>
            {t('Header.Logout')}
          </button>
        )}
      </nav>
    </header>
  );
};

export default Header;